import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-orderplanning-customer-selection-custom-config',
    templateUrl: './customer-selection-custom-config.component.html',
    standalone: false,
})
export class OrderplanningCustomerSelectionCustomConfigComponent implements OnInit {
  cropYear: number;

  ngOnInit(): void {
    this.cropYear = new Date().getFullYear();
  }
}
